export default {

    //General phrases
    tollWord: 'fetesti híd dija|  fetesti híd díjai| Peaje',
    vignetteWord: 'vignetta|vignetták',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'lej',
    category: 'kategória',
    select_type_of_vehicle: 'Válaszd ki a jármű típusát',
    select_the_period: 'Select the period',
    or_pay_for: 'vagy fizesd ki ennek esetében',
    your_vehicles_link: 'a te járműveid',
    or_go_to_your_account_and_buy: 'vagy lépj be a fiókodba és vásárolj közvetlenül a járműveidnek',
    see_cart: 'lásd a kosarat',
    or: 'vagy',
    and: 'és',
    back: 'vissza',
    total: 'összesen',
    pf: 'természetes személy',
    pj: 'jogi személy',
    yes: 'igen',
    no: 'Nem',
    about: 'róla',
    us: 'rólunk',

    vignette: 'vignetta | vignetták',
    passing: 'átjárás | átjárások',

    toll_buy: 'Fizesd ki a híd díját',
    vignette_buy: 'Fizesd ki a vignettát',

    //Order
    billing_add_new_profile: 'Adj hozzá új számlázási profilt',

    cart_empty: 'Üres kosár',
    cart_available_from: 'érvényesség kezdete',
    cart_add_more: 'Egyebek hozzáadása a kosárba',
    cart_continue_with_buying: 'Még vásárolj',
    cart_validation_errors: 'megrendelésből kiürített termékek érvényességi hibák miatt',

    order_container_place_order_title: 'Küldd a megrendelést',
    order_container_my_cart: 'A kosaram',
    order_container_billing_info: 'Számlázási adatok',
    order_container_payment: 'Fizetés',

    payment_method_insuficient_credit: 'elégtelen összeg',
    payment_method_instant_credit: ' instant hitel',
    payment_method_instant_credit_description: ' instant hitel',
    payment_method_credit_card: 'Online bankkártyával',
    payment_method_credit_card_description: 'PayU.ro által feldolgozott fizetés',
    payment_method_iTransfer_description: 'Fizetési meghagyás azonnali visszaigazolással',
    payment_method_payment_order: 'Fizetési meghagyás',
    payment_method_payment_order_description: 'Proform emailt fogsz kapni a beszerzés mellékleteként, amely tartalmazza a fizetési meghagyásokat. Az összeg beérkezésekor a megrendelés kiállítva',
    payment_method_credit_erv: ' e-vignetta hitel',
    payment_method_credit_tpf: ' fetesti híd díj hitel',
    payment_method_terms: 'Megerősítem, hogy a fenti adatok helyesek és egyetértek a feltételekkel',

    thank_you_placed_order_title: 'Megrendelés elküldve',
    thank_you_successful_order: 'Sikeresen elküldött megrendelés!',
    thank_you_see_info_order: 'Lásd a státuszát a megrendeléseimben',
    thank_you_my_orders: 'Megrendeléseim',

    //Account
    continue_with: 'Continue with',
    account_activate_header: 'Aktiváld a fiókot',
    account_activate_message: '',

    account_container_my_account: 'Az én fiókom',
    account_container_vehicles: 'Járművek',
    account_container_orders: 'Megrendelések',
    account_container_profiles: 'Számlázási profilok',
    account_container_info: 'Fiók adatai',

    account_data_title: 'Fiók részletek',

    add_car_title: 'Jármű hozzáadása',

    add_profile_title: ' profil hozzáadása',
    add_profile_pj_extracted: 'Jogi személy automatikusan kivont adatai ',

    edit_car_no_vehicles: 'Egyetlen jármű találat sem!',
    edit_car_delete_vehicle_title: 'Jármű törlése',
    edit_car_delete_vehicle: 'Biztos, hogy törölni akarod a járművet?',

    my_orders_passings: 'egy áthaladás | {count} áthaladások',

    profiles_main: 'Fő',
    profiles_secondary: 'Mellék',
    profiles_unverified_data: 'Ellenőrzás nélküli adatok',
    profiles_no_profile: 'Nincs egyetlen profil sem',
    profiles_delete_profile: ' profil törlése',
    profiles_are_you_sure: 'Biztos vagy a profil törlésében?',

    //Authentication
    login_auth: 'Bejelentkezés',
    login_login_into_your_account: 'Belépés a fiókodba',

    login_component_login_by: 'Belépés ezzel',
    login_component_no_account: 'Nincs fiókod?',
    login_component_forgot_password: 'Elfelejtette a jelszavát?',

    new_account_title: 'Új fiók létrehozása',
    new_account_details: 'Fiók részletei',
    new_account_ive_read: 'Elolvastam és egyetértek ezzel',
    new_account_tc: 'általános feltételek',
    new_account_site: 'site',
    new_account_pc: 'bizalmassági politika',
    mandatory: 'Kötelező',
    new_account_must_accept_tc: 'El kell fogadnod a feltételeket',
    new_account_must_accept_pc: 'El kell fogadnod a bizalmassági politikát',

    contact_title: 'Kapcsolat',

    header_how_does_it_work: 'Hogyan működik?',

    how_it_works_p1: '3 perc műlva útnak indulsz!',
    how_it_works_p2: ' CNAIR engedélyezett forgalmazója',
    how_it_works_p3: 'online megrendelés  taxa-pod-fetesti.ro',

    toll_category_error_loading_car: 'Probléma a jármű feltöltésénél',
    toll_category_error_loading_country: 'Probléma az államok feltöltésénél',

    vignette_category_error_fromdate: 'Ettől a naptól lép érvénybe a vignetta',

    //Buttons
    btn_save: 'Mentés',
    btn_save_changes: 'Mentsd le a módosításokat',
    btn_add_car: 'Jármű hozzáadása',
    btn_delete_car: 'Töröld a járművet',
    btn_next_step: 'Következő lépés',
    btn_finish: 'Véglegesítsd',
    btn_grab_data_company: 'Adatok átvétele<br/> Cégbíróság',
    btn_add_profile: 'Új profil hozzáadása',
    btn_i_understand: 'Megértettem',
    btn_login: 'Login',
    btn_register: 'Bejelentkezés',
    btn_create_account: 'Fiók létrehozása',
    btn_add_to_cart: 'Kosárba',
    btn_edit_to_cart: 'Termék módosítása',
    btn_reset_password: 'Jelszó visszaállítása',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'Email',
    label_password: 'Jelszó',
    label_confirm_password: 'Jelszó megerősítése',
    label_license_plate: 'Forgalmi rendszáma',
    label_chasis_number: 'Alvázszám',
    label_registration_country: 'Forgalombahelyezés állama',
    label_motif: 'Alsóbb kategória oka',
    label_choose_category: 'Katgória kiválasztása',
    label_billing_type: 'Számlázási adatok',
    label_last_name: 'Utónév',
    label_first_name: 'Családnév',
    label_country: 'Ország',
    label_county: 'Megye',
    label_city: 'Város',
    label_address: 'Lakcím',
    label_cui: 'adószám',
    label_reg_com: 'Cégbíróság',
    label_locality: 'Település',
    label_company_name: 'Társaság megnevezése',
    label_for_car: 'Jármű esetében',
    label_available_from: 'Érvényesség kezdete',

    //terms
    terms: 'Felhasználási feltételek',
    partners: 'partner',

    delete_product_title: 'Delete product',
    delete_product: 'Are you sure you want to delete this product?',

    //New terms
    btn_edit: 'Módosítson',
    btn_edit_password: 'Módosítsa a jelszót',
    btn_edit_phone: 'Módosítsa a telefonszámot',
    btn_delete_account: 'Törölje a fiókot',
    btn_import_csv: 'Import csv',
    btn_export_csv: 'Export csv',

    //account
    data_saved_succesfully: 'Az adatok mentése sikeres volt',
    invalid_plate_number_message: 'A szám nincs megfelelően formázva',
    invalid: 'Nem érvényes',
    countries_loading: 'Probléma az országok betöltésekor',
    tpf_categories_loading: 'Probléma a fetesti híddíj-kategóriák betöltése során',
    erv_categories_loading: 'Probléma a matrica kategóriák betöltésével',
    csv_header: 'Szám, Alvázszám, Matrica kategória, fetesti híddíj kategória, Ország',
    order_header_name: 'Nem',
    date: 'Dátum',
    order_header_payment_type: 'Fizetés típusa',
    order_header_status: 'Állapot',
    no_placed_order: ' Nincs beadott megrendelés.',
    i_want: 'Akarom',
    no_order: 'A megrendelést nem lehetett megtalálni.',

    product_status: 'Állapot',
    product_payment_method: 'Fizetési mód',
    product_bill_data: 'Számlázási adatok',
    product_valability: 'Érvényesség',

    download_bill: 'Töltse le a számlát',
    vignette_series: 'Matrica sorszáma',
    toll_series: 'Híd díj sorszáma',

    //authentication
    login_account: 'Lépjen be a fiókba',
    already_have_account: 'Már van fiókja?',
    password: 'Jelszó',
    password_confirm: 'Ismételje a jelszót',
    return_to_login_1: 'Térjen vissza az … oldalra',
    return_to_login_2: 'Belépés',

    // order
    choose_profile: 'Válasszon egy profilt',
    order_step4: '4.Lépés: Számlázás',
    login_to_your_account: ' Jelentkezzen be a fiókjába',
    login_to_your_account_2: 'és válassza ki a már elmentett számlázási adatokat.',
    order_without_account: ' A megrendelést fiók nélkül is leadhatja az alábbi adatok kitöltésével',
    fill_all_fields: 'Töltse ki az összes kötelező mezőt',
    order_address_info: 'Ezen a címen megkapja a számlát és a matricát',
    invalid_profile_msg: 'Ez a profil érvénytelen',
    delete_profile_msg: 'Profil törlése',
    delete_profile_confirm: 'Biztosan akarja törölni a profilt?',
    invalid_email: 'Email érvénytelen',
    invalid_tel: 'Telefon érvénytelen',
    mandatory_city: 'A város kötelező',
    mandatory_first_name: 'A keresztnév kötelező',
    mandatory_last_name: 'A családnév kötelező',
    mandatory_country: 'A megye kötelező',
    mandatory_fiscal_code: 'Az egyedi adóazonosító kódszám kötelező',
    mandatory_j_code: 'A Kereskedelmi Nyilvántartás kötelező',
    mandatory_company: 'A cég kötelező',
    mandatory_address: 'A cím kötelező',
    my_shopping_cart: 'Az én kosaram',
    order_step3: '3. lépés: Összegzés',
    buy_vignette_or_bridge_fee: 'Vásárolhat matricát vagy Fetești híd díjat',
    order_step5: '5. Lépés: Fizetés',
    warning: 'FIGYELEM!',
    warning_txt_1: ' A matrica fizetési meghagyással történő kifizetésére a megbízást a pénz UNTRR bankszámláján történő behajtása után hagyják jóvá.',
    warning_txt_2: ' A fizetési megbízással fizetett matricákat hétfőtől péntekig 08:00 és 16:30 között adják ki.',
    warning_txt_3: 'Ne induljon útra, amíg nem kap megerősítést a matrica kibocsátásáról.',
    warning_txt_4: 'Az UNTRR nem felelős a fenti feltételek be nem tartásáért!',
    choose_card: 'Válasszon egyet a mentett kártyák közül',
    new_card: 'Új kártya',
    add_card_for_next_transactions: ' Adja hozzá a kártyát a számlámhoz a jövőbeli vásárlásokhoz',

    free: 'Díjmentesen',
    btn_logout: 'Log out',
    info: 'Info',

    frequent_questions_heading: 'Gyakran feltett kérdések és válaszok',
    see_all_frequent_questions: 'Az összes kérdés és válasz megtekintése',

    step: 'Step {n}',
    choose_passings_number: 'Válassza ki az áthaladások számát',
    vehicles: 'Gépjárművek',

    juridical_person: 'Jogi személy',
    individual_person: 'Természetes személy',
    auto_query_company_data: 'Automatikusan átvesszük a cég adatait',
    verified_company_data: 'A cég adatai ellenőrizve!',
    unverified_company_data: 'Ellenőrizetlen cégadatok',
    check_vignette_valability: 'Ellenőrizze a matrica érvényességét',
    resources: 'Erőforrások',
    i_want_vignette: 'Akarok matricát',
    i_want_toll: 'Akarok Fetești híd díjat',
    vehicle_type: 'Jármű típusa',
    period: 'Időszak',
    summary: 'Összesítés',
    billing: 'Számlázás',
    payment: 'Fizetés',
    you_have_multiple_usernames: '<b> {count} </b> fiókkal rendelkezik ehhez az e-mailhez.',
    choose_login_account: ' Válassza ki a fiókot, amellyel bejelentkezni szeretne',

    //benefits page
    bp_company_advantages: 'Előnyök a vállalatok számára',
    bp_one_account_multiple_advantages: 'Egy számla, több előny',
    bp_contact_us_for_personalized_solution: ' Vegye fel velünk a kapcsolatot a testreszabott megoldásra',
    bp_online_emission: 'Online kiadás 24/7',
    bp_online_assistance: 'Online támogatással rendelkezik, és a matricát vagy a Fetești hídadót 24/7 veheti meg',
    bp_import_your_cars: 'Importálja a teljes flottát',
    bp_import_you_cars_through_excel: 'Importálja nálunk a vállalat teljes autóparkját, egy Excel fájl alapján.',
    bp_multiple_profiles: 'Több profil',
    bp_multiple_profiles_for_same_email: 'Több profilt hozhat létre minden üzleti felhasználó számára ugyanazzal az e-mail címmel.',
    bp_vignettes_status: 'Matricák állapota',
    bp_verify_vignette_status: 'A weboldalon mindig ellenőrizheti a kiadott matricák állapotát.',
    bp_orders_history: 'Istoric comenzi',
    bp_orders_history_description: 'A fiókon megtalálható az összes leadott megrendelés és számla.',
    bp_multiple_orders: 'Comenzi multiple',
    bp_multiple_orders_description: 'Felvehet több matricát a kosárba, és több megrendelést is leadhat.',
    bp_email_sms_confirmation: 'E-mail és SMS visszaigazolás',
    bp_email_sms_confirmation_description: 'Megerősítést kap a matrica kibocsátásáról e-mailben és SMS-ben.',
    bp_expiry_alerts: 'Lejárati figyelmeztetések',
    bp_expiry_alerts_description: '30 napos és több mint 30 napos matricák esetében e-mailben figyelmeztetünk, mielőtt lejárnak.',
    bp_need_help: 'Segítségre van szüksége?',
    bp_call_operators: 'Hívja fel egyik operátorunkat segítségért a matricák kiadásában. A szolgáltatás hétfőtől péntekig (a munkaszüneti napok kivételével) 8 és 17 óra között áll rendelkezésre.',
    bp_offices: 'A képviseletek listája',
    bp_have_cars: 'Van gépjárműparkja?',
    bp_contact_us_for_personalized_solution_for_your_bussiness: 'Vegye fel velünk a kapcsolatot, hogy személyre szabott megoldást kínálhassunbk vállalkozásának.',
    bp_contact_us_now: 'Vegye fel velünk a kapcsolatot most',


    //contact
    contact_viggnete_emission: 'Matrica kiadása',
    contact_agencies: 'Ügynökség',
    contact_see_all_agencies: 'Lásd az összes regionális ügynökséget',
    contact_see_all_agencies_continuation: 'ahonnan lehet matricát kapni.',

    //distribution
    distribution_header: 'A ROMÁN NEMZETI KÖZÚTI HÁLÓZAT HASZNÁLATÁRA VONATKOZÓ DÍJ BEVÉTELÉRE FELHATALMAZOTT, UNTRR-hoz TARTOZÓ MUNKAPONTOK LISTÁJA (MATRICA)',
    distribution_nr_crt: 'Sorszám',
    distribution_work_point: 'Munkapont',
    distribution_terminals_and_portals: 'WEBTERMINÁLOK ÉS PORTÁLOK',
    distribution_name: 'Elnevezés',
    distribution_terminals: 'ZEBRAPAY Terminálok',
    distribution_location_terminal_details: 'ZEBRAPAY terminálok elhelyezési részletek',
    distribution_untrr_portal: 'UNTRR PORTÁL',


    //footer
    footer_copyright: 'Minden jog fenntartva 2010 - 2020 @ Uniunea Naţională a Transportatorilor Rutieri din România.',


    //homepage
    homepage_authorized_distributor: 'C.N.A.I.R által engedélyezett elosztó',
    homepage_buy_tpf_erv: ' Vásároljon matricát vagy Fetești hídadót',
    homepage_ready_for_road: 'Most indulásra kész',
    homepage_order: 'Megrendelés',
    homepage_payment: 'Fizetni',
    homepage_drive: 'Utazni',
    homepage_your_advantages: 'Előnyei',
    homepage_vignette_availability: 'Ellenőrizze a matrica érvényességét.',
    homepage_vignette_availability_description_1: 'Nem tudja, van-e érvényes matricája? Kerülje a bírságot.',
    homepage_vignette_availability_description_2: 'Itt ellenőrizheti az érvényességet ',
    homepage_save_data: 'Adatok mentése',
    homepage_save_data_description: 'Fiókot készít, elmenti az autó adatait, és egy helyen megvásárolja a matricát és a Fetești híd díjat.',
    homepage_sms_email_delivery: 'Kézbesítés e-mailben és SMS-ben',
    homepage_sms_email_delivery_description: 'Kézbesítés e-mailben és SMS-ben',
    homepage_card_or_op: 'Fizessen kártyával vagy fizetési megbízással',
    homepage_card_or_op_description: ' Gyors és biztonságos vásárlás bankkártyával vagy fizetési megbízással.',
    homepage_notify_expiry: 'Lejárati értesítés',
    homepage_notify_expiry_description: ' A 30 napnál hosszabb ideig érvényes matrica esetében figyelmeztetünk, mielőtt lejár.',
    homepage_professional_services: 'Professzionális szolgáltatások',
    homepage_professional_services_description: 'Közlekedési szakemberektől a romániai úthálózat minden felhasználója számára Közlekedési szakemberektől kezdve a romániai úthálózat minden felhasználója számára.',
    homepage_online_assistance: 'Ezen felül online támogatást és testreszabott megoldást kínál üzleti igényeihez.',
    homepage_discover_all_benefits: 'Fedezze fel az összes előnyt',
    homepage_distribution_points: 'Elosztási pontok',
    homepage_authorized_distributor_2: ' Az UNTRR a C.N.A.I.R. által engedélyezett kiadó online és a területi pontokon az elektronikus matricák kiadására.',
    homepage_distribution_points_description: 'Az elosztási pontok listájának megtekintése',
    homepage_frequent_questions: 'Gyakori kérdések és válaszok',
    homepage_frequent_questions_description: 'Lásd az összes kérdést és választ',

    //info
    info_download_file: 'Töltse le a fájlt',

    //reset
    reset_cart: 'A kosár vissza lett állítva',

    sms_notice: '<strong>Fizetett SMS értesítési szolgáltatás</strong><br/><br/> A rövid üzenetküldő szolgáltatás (SMS) lehetővé teszi a www.taxa-pod-fetesti.ro ügyfelek értesítését a hídhasználati díj kiállításának megerősítéséről, illetve az ügyfelek értesítését a hídhasználati díj érvényességének lejártáról. A szolgáltatás opcionális, az ügyfél választása szerint, és csak a fizetésfeldolgozón (PayU) keresztül online kifizetett megrendelésekre érvényes.<br/><br/> Az www.taxa-pod-fetesti.ro platformon megadott, a hídhasználati díj kiállításával kapcsolatos SMS-ben szereplő adatok és információk, a regisztrációs szám, az alváz sorszám és a mobiltelefonszám helyességéért szigorúan a felhasználó felelős.<br/><br/> Az SMS-értesítés a NETOPIA Payments-en keresztül történik.<br/><br/> Az SMS értesítési rendszer értesítést küld azoknak az ügyfeleknek, akik ezt a szolgáltatást választják.<br/><br/> A visszaigazoló SMS fogadását befolyásolhatja a távközlési hálózatok működése, lefedettsége, a használt eszközök működése stb.<br/><br/> Az értesítésekért kérjük, használja az www.taxa-pod-fetesti.ro webhely kapcsolatfelvételi oldalát.<br/><br/>'
};
